import { render, staticRenderFns } from "./cart-slider.component.vue?vue&type=template&id=5b2cd9ca&"
import script from "./cart-slider.component.vue?vue&type=script&lang=ts&"
export * from "./cart-slider.component.vue?vue&type=script&lang=ts&"
import style0 from "./cart-slider.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cart-slider.component.vue"
export default component.exports